import HttpService from '@bnr-dev/http-service/HttpService';
import AuthService from '@bnr-dev/auth-service/AuthService';
import TokenService from '@bnr-dev/token-service/TokenService';
import ModuleRedirectService from '@/service/ModuleRedirectService';

const singleton = Symbol();
const singletonEnforcer = Symbol();

class ServiceContainer {
    constructor(enforcer) {
        if (enforcer !== singletonEnforcer) {
            throw new Error('Cannot construct singleton');
        }

        this.tokenService = new TokenService();
        this.httpService = new HttpService(
            this.tokenService,
            process.env.VUE_APP_DOMAIN_URL,
            [{ key: 'BnrDevCorsEnabled', value: true }]
        );
        this.authService = new AuthService(
            this.httpService,
            this.tokenService,
            {
                baseUrl: 'taxifix/auth/',
                signOutOnIdle: false
            }
        );
        this.moduleRedirectService = new ModuleRedirectService();
    }

    static get instance() {
        if (!this[singleton]) {
            this[singleton] = new ServiceContainer(singletonEnforcer);
        }

        return this[singleton];
    }
}

export default ServiceContainer;
